module.exports = __webpack_public_path__ + "img/36_40.c41493fd.png";